/*------------------------------------*\
    Field Validation
\*------------------------------------*/
const translate = require('../../site/_data/i18n');

// Get locale from URL
const pathArray = window.location.pathname.split('/');
const locale = pathArray[1];

class FieldValidation {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.validateFields = document.querySelector('[data-save-button]');
        self.field = self.elem.querySelector('[data-validate-field]');
        self.validationMessage = self.elem.querySelector('[data-validation-message]');
    }

    init() {
        let self = this;

        self.validateFields.addEventListener('click', (evt) => {
            evt.preventDefault();

            if (self.field.required) {
                self.validateField();
            }
        });
    }

    validateField() {
        let self = this;

        const emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        const inputText = self.field.value.trim();

            
        if (self.field.type == 'email') {
            if (inputText.match(emailFormat)) {
                self.validationMessage.classList.add('d-none');
                self.field.classList.remove('is-invalid');

                return true;
            } else {
                self.validationMessage.classList.remove('d-none');
                self.validationMessage.innerText =  translate.form.error.email[locale];
                self.field.classList.add('is-invalid');
                    
                return false;
            }
        }
        
        if (inputText !== '') {
            self.validationMessage.classList.add('d-none');
            self.field.classList.remove('is-invalid');
            
            return true;
        } else {
            self.validationMessage.classList.remove('d-none');
            self.validationMessage.innerText = `${self.field.dataset.label} ${translate.form.error.required[locale]}`;
            self.field.classList.add('is-invalid');
                
            return false;
        }
    }
}

export default FieldValidation;